import { Component } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MediaService } from "src/app/core/services/media.service";
import { UploadGalleryComponent } from "src/app/shared/ui/upload-gallery/upload-gallery.component";
import * as ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-cta-values",
  templateUrl: "./cta-values.component.html",
  styleUrls: ["./cta-values.component.scss"],
})
export class CtaValuesComponent {
  public Editor = ClassicEditor;
  isSubmitted = false;
  ctaForm: FormGroup;
  allMedia: any;
  isUpdating = false;
  deletedctaBlog: any[] = [];
  loadingCtaValues = false;

  constructor(
    private api: MediaService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.resetForm();
    this.getUsefulMedia();
  }

  resetForm() {
    this.ctaForm = this.fb.group({
      blog_id: [null, [Validators.required]],
      cta_values: this.fb.array([]),
    });
  }

  getUsefulMedia() {
    this.api.getUsefulMedia(1).subscribe((result: any[]) => {
      this.allMedia = result;
    });
  }

  onBlogChange(blogId: any) {
    this.loadingCtaValues = true;

    const selectedBlog = this.allMedia.find((blog) => blog.id === blogId);
    const ctaArray = this.ctaForm.get("cta_values") as FormArray;
    ctaArray.clear();

    setTimeout(() => {
      if (selectedBlog?.cta_values?.length) {
        selectedBlog.cta_values.forEach((cta) => {
          ctaArray.push(
            this.fb.group({
              icon: [cta.icon || ""],
              link: [cta.link || ""],
              heading: [cta.heading || ""],
              cta_text: [cta.cta_text || ""],
            })
          );
        });
      } else {
        // Push one blank item if none exist
        ctaArray.push(
          this.fb.group({
            icon: [""],
            link: [""],
            heading: [""],
            cta_text: [""],
          })
        );
      }

      this.loadingCtaValues = false;
    }, 300);
  }

  get cta_values(): FormArray {
    return this.ctaForm.get("cta_values") as FormArray;
  }

  addNewCta() {
    this.cta_values.push(
      this.fb.group({
        icon: [""],
        link: [""],
        heading: [""],
        cta_text: [""],
      })
    );
  }
  deleteCta(index: number) {
    this.cta_values.removeAt(index);
  }

  onSubmit(ctaForm: FormGroup) {
    if (ctaForm.valid) {
      this.isUpdating = true;
      const formData = ctaForm.value;
      this.api.setCtaValues(formData).subscribe(
        (response) => {
          this.isUpdating = false;
          this.toastr.success("CTA values updated successfully!");
          this.resetForm();
          this.getUsefulMedia();
        },
        (error) => {
          this.isUpdating = false;
          console.error("Error saving media", error);
        }
      );
    } else {
      console.error("Form is invalid");
    }
  }

  openUploadModal(field: string, ctaIndex: number): void {
    const modalRef = this.modalService.open(UploadGalleryComponent, {
      size: "xl",
      scrollable: true,
      windowClass: "modal-big-lg",
      keyboard: false,
      backdrop: "static",
    });

    modalRef.componentInstance.uploadDetails = {};

    modalRef.result
      .then((result) => {
        if (result.status && field === "cta_values_icon") {
          const ctaFormArray = this.ctaForm.get("cta_values") as FormArray;
          const ctaFormGroup = ctaFormArray.at(ctaIndex) as FormGroup;
          ctaFormGroup.get("icon")?.setValue(result.image);
        }
      })
      .catch(() => {});
  }

  // socialMediaArray(i: number): FormArray {
  //   return this.blogcta().at(i).get("cta_values") as FormArray;
  // }
}
